
import { Pagination, Navigation } from "swiper";

export default {
  props: {
    images: { type: Array, required: true },
    getImageOptions: { type: Function, default: () => {} },
  },

  data: () => ({ swiper: null }),

  computed: {
    swiperOptions() {
      return {
        autoHeight: false,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        loop: true,
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: ".pdp-image-nav-next",
          prevEl: ".pdp-image-nav-prev",
        },
        pagination: {
          el: ".pdp-image-swiper-pagination",
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className}">&nbsp;&nbsp;</span>`,
        },
      };
    },
  },

  async mounted() {
    await this.$swiper.init(".swiper.pdp-image", this.swiperOptions);
  },

  destroyed() {
    this.$swiper.destroy(".swiper.pdp-image");
  },
};
